const marques = [
  {
    title: "Somfy",
    desc: "Télécommandes et points de commande Somfy : Telis, Smoove, Situo et Chronis. Remplacement et reprogrammation de tous les modèles de commande radio et filaire.",
    icon: "ri-remote-control-line",
  },
  {
    title: "Nice",
    desc: "Télécommandes et points de commande Nice : Era One, Inti et Opera. Remplacement et reprogrammation des commandes radio et filaires pour moteurs Nice.",
    icon: "ri-remote-control-line",
  },
  {
    title: "Simu",
    desc: "Télécommandes et points de commande Simu : Hz, T5 et live-in. Remplacement et reprogrammation des commandes radio et filaires pour moteurs Simu.",
    icon: "ri-remote-control-line",
  },
  {
    title: "Autres marques",
    desc: "Nous intervenons aussi sur toutes les autres marques de télécommandes et points de commande : BFT, Faac, Came et autres motorisations de volet roulant.",
    icon: "ri-tools-line",
  },
];

export default function Marques() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <h2 className="text-[#1B2A4A] text-2xl md:text-3xl font-extrabold text-center mb-3">
          Marques installées
        </h2>
        <p className="text-[#2F4A63] text-base text-center mb-10 md:mb-14 max-w-2xl mx-auto">
          Nous remplaçons et reprogrammons les télécommandes et points de commande des principales marques de motorisation de volet roulant.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {marques.map((marque) => (
            <div
              key={marque.title}
              className="bg-[#F5F2EB] rounded-xl border border-[#E2E8F0] p-5 md:p-6 hover:border-[#E8734A]/40 transition-colors"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#E8734A]/10 mb-4">
                <i className={`${marque.icon} text-[#E8734A] text-lg`}></i>
              </div>
              <h3 className="text-[#1B2A4A] text-base font-bold mb-2">{marque.title}</h3>
              <p className="text-[#2F4A63] text-sm leading-relaxed">{marque.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}